import React, { useMemo } from "react"
import { Routes, Route } from "react-router-dom"
import { AnimatePresence } from "framer-motion"

import _ from "lodash"

import config from "config"

import { useVenue } from "providers/venue"

// Extensions
import {
  getAllExtensionRoutes,
  getExtensionThemeFactories,
  mergeRoutes,
  registerRouteByConfig,
} from "utils/extension"
import { extensionConfigs } from "extensions"

// Theme
import { generateTheme } from "theme/generateTheme"
import { appThemeOptionFactory as directoryThemeOptionFactory } from "theme/app/directory"
import { ThemeProvider } from "providers/mui-extended/ThemeProvider"

// Routes
import { initialRoutes } from "standard"

// Pages
import { HomePage } from "pages/home/index.base"

// Components, Layouts
import { BaseAppLayout } from "layouts/BaseAppLayout"
import { ScrollToTop } from "components/ScrollToTop"
import { LoadingScreen } from "components/LoadingScreen"
import { MotionDiv, showContent } from "components/motions"
import { DEVICE_MOBILE } from "constant"

// Extension routes
const extensionRoutes = getAllExtensionRoutes(
  config("venueExtension"),
  extensionConfigs,
  DEVICE_MOBILE
)

// Merge Standard + Extension routes
const { pageRoutes, baseRoutes } = mergeRoutes(
  _.get(initialRoutes, DEVICE_MOBILE),
  extensionRoutes
)

// Extension Themes
const extensionThemeConfig = getExtensionThemeFactories(
  config("venueExtension"),
  extensionConfigs
)

// App Theme Factory
const appThemeOptionFactory = _.get(directoryThemeOptionFactory, DEVICE_MOBILE)

export const BaseApp = () => {
  // Generate a venue theme
  const { themeOptions: venueThemeOptions, dataLoaded } = useVenue()
  const theme = generateTheme(venueThemeOptions, appThemeOptionFactory, {
    extendThemeFactories: extensionThemeConfig.themeFactories,
    ignoreAppThemeFactory: extensionThemeConfig.ignoreAppThemeFactory,
  })

  const isAppReady = useMemo(() => dataLoaded, [dataLoaded])

  return (
    <ThemeProvider theme={theme}>
      <ScrollToTop />
      <AnimatePresence mode="sync">
        {!isAppReady && <LoadingScreen key="loading-screen" />}
        <MotionDiv
          key="content"
          variants={showContent}
          initial="initial"
          animate="animate"
        >
          <Routes>
            <Route path="/" element={<BaseAppLayout />}>
              {baseRoutes.map(registerRouteByConfig)}
              <Route index element={<HomePage />} />
              <Route path="/*">
                {/* Add or override specific route extension pages here. */}
                {pageRoutes.map(registerRouteByConfig)}
              </Route>
            </Route>
          </Routes>
        </MotionDiv>
      </AnimatePresence>
    </ThemeProvider>
  )
}
